import React from "react";
import Helmet from "react-helmet";

const Head = ({ img_url, description }) => {
  return (
    <Helmet>
      <script type="application/javascript">
        {`{(function(d) {
            var config = {
              kitId: 'xhp7juq',
              scriptTimeout: 3000,
              async: true
            },
            h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\\bwf-loading\\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
          })(document);}`}
      </script>
      <title>Euph & Tuba Carnival 4th</title>
      <meta title="Euph & Tuba Carnival 4th" />
      <head prefix="og: http://ogp.me/ns#" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="ETC4th" />
      <meta
        property="og:description"
        content={
          description || "Euph&Tuba Carnival 4th の演奏会情報、奏者募集はコチラ"
        }
      />
      <meta property="og:image" content={img_url} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default Head;
